<template>
    <div class="chat">
        <div class="content-pc">
            <div class="head">
                <router-link to="/Login">
                    <img style="margin-left:40px;" src="../../assets/img/site-logo.png" alt="">
                </router-link>
                <div class="nav-list" style="display:inline-block;float:right;">
                    <a href="http://www.ixiaowen.net/ai%E8%AF%AD%E9%9F%B3/">公司产品</a>
                    <a href="http://www.ixiaowen.net/%e6%99%ba%e6%85%a7%e9%80%9a%e4%bf%a1/">解决方案</a>
                    <a href="http://www.ixiaowen.net/category/qb/">场景体验</a>
                    <a href="http://www.ixiaowen.net/bbs/">技术支持</a>
                    <a href="http://www.ixiaowen.net/%e5%85%ac%e5%8f%b8%e4%bb%8b%e7%bb%8d/">关于我们</a>
                </div>
            </div>
            <div class="content">
                <div class="content-left">
                    <div class="item-top">
                        <div style="color:rgba(51, 51, 51, 1);font-size:18px;font-weight:bold">项目简介</div>
                        <a-divider style="margin:16px 0 0 0" />
                        <div style="color:rgba(80, 80, 80, 1);font-size:14px;margin-top:24px;margin-bottom:8px;">项目名称</div>
                        <div style="color:rgba(0, 0, 0, 1);font-size:16px;font-weight:bold">
                            <a id="projectName" style="color:#000;" target="view_window" :href='projectUrl'>
                                {{projectName}}
                            </a>
                        </div>
                        <div style="color:rgba(80, 80, 80, 1);font-size:14px;margin-top:24px;">项目介绍：</div>
                        <div style="color:rgba(153, 153, 153, 1);font-size:14px;margin-top:8px;word-break:break-all">{{des}}</div>
                    </div>
                    <div class="item-bottom">
                        <div style="color:rgba(51, 51, 51, 1);font-size:18px;font-weight:bold">电话体验</div>
                        <a-divider style="margin:16px 0 0 0" />
                        <div style="color:rgba(80, 80, 80, 1);font-size:14px;margin-top:24px;">请输入您的手机号：</div>
                        <a-input v-model="userPhone" v-bind:disabled="ifCanUse" style="width:312px;height:40px;margin-top:8px;border:1px solid rgba(65, 224, 230, 1);border-radius:4px;">
                            <a-icon slot="prefix" type="user" />
                        </a-input>
                        <div style="display:flex;margin-top:8px;">
                            <span style="display:inline-block;width:10px;color:rgba(34, 215, 187, 1)">*</span>
                            <div style="flex:1;color:rgba(204, 204, 204, 1);font-size:12px;">温馨提示：您输入的手机号仅用于电话模拟，不用于其他任何地方，我们会保护您的隐私安全，请放心试用。</div>
                        </div>
                        <div style="text-align:right;margin-top:24px;">
                            <a-button class="submit-btn" v-bind:disabled="ifCanUse" @click="playCall('pc')" style="padding:0 15px;height:32px;line-height:32px;text-align:center;color:#fff;border-radius:4px;background:rgba(65, 224, 230, 1);display:inline-block;">{{buttonHtml}}</a-button>
                            <a-button class="submit-btn" v-if="ifRestart" @click="restartCall()" style="padding:0 15px;height:32px;line-height:32px;text-align:center;color:#fff;border-radius:4px;background:#F8B250;display:inline-block;margin-left:20px;border:none">重新呼叫</a-button>
                        </div>
                    </div>
                </div>
                <div class="content-middle">
                    <div style="flex:1;padding:0 0 16px 24px;display:flex;flex-direction: column;">
                        <div style="color:rgba(51, 51, 51, 1);font-size:18px;font-weight:bold">文字模拟-{{projectName}}</div>
                        <a-divider style="margin:16px 0 0 0" />
                        <div style="flex:1;position:relative">
                            <div id="chatDiv" style="position:absolute;width:100%;height:100%;overflow-y:auto;padding:24px 0">
                                <div v-for="(item, index) in privateChatContent" :key="index">
                                    <div v-if="item.role=='robot'&&item.content!=''" style="float:left;max-width:60%;display:flex;">
                                        <img style="width:32px;height:32px;margin-right:12px;" src="../../assets/img/chat-head.png" alt="">
                                        <div style="flex:1;padding:8px 12px;background:#fff;border-radius:4px;color:rgba(80, 80, 80, 1);font-size:14px;">{{item.content}}</div>
                                    </div>

                                    <div v-if="item.role=='user'&&item.content!=''" @click="queryUserIntentionData(index,item.content)" style="float:right;max-width:60%;padding:8px 12px;background:rgba(65, 224, 230, 1);color:#fff;font-size:14px;border-radius:4px;margin-right:24px;cursor:pointer;">
                                        {{item.content}}
                                    </div>
                                    <div style="clear:both;width:100%;height:16px;"></div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div style="height:120px;background:#fff;position:relative" v-if="!ifCanOperate">
                        <div v-if="isEnd" style="position:absolute;top:-30px;left:50%;font-size:16px;color:#000;margin-left:-40px">通话已结束</div>
                        <a-textarea v-model="privateContent" style="resize:none;border:none;height:120px;" :disabled="isFinish" placeholder="请输入对话内容" auto-size  @keyup.13="sendPrivate" />
                        <a-button class="resetText" @click="resetPrivate" type="link" icon="redo" style="border:none;font-size:14px;position:absolute;right:76px;bottom:4px;">
                            重置
                        </a-button>
                        <a-button class="resetText" @click="sendPrivate" type="link" style="border:none;font-size:14px;position:absolute;right:24px;bottom:4px;">
                            发送
                        </a-button>
                    </div>
                </div>
                <div class="content-right">
                    <div style="color:rgba(51, 51, 51, 1);font-size:18px;font-weight:bold">意图识别</div>
                    <a-divider style="margin:16px 0 0 0" />
                    <div style="color:rgba(80, 80, 80, 1);font-size:14px;margin-top:24px;margin-bottom:8px;">您输入的内容：</div>
                    <div style="color:rgba(65, 224, 230, 1);font-size:14px;margin-top:8px;">{{currentWord}}</div>
                    <div style="color:rgba(80, 80, 80, 1);font-size:14px;margin-top:24px;">小文智能交互识别您的意图为：</div>
                    <div v-for="(item, index) in intentionList" :key="index" style="margin-top:12px;">
                        <div v-if="index<3">
                            <div style="color:rgba(153, 153, 153, 1);font-size:12px;margin-top:16px;">top{{index+1}}:{{item.name}}</div>
                            <a-progress :percent="Number(((item.score)*100).toFixed(0))" status="active" strokeColor="rgba(65, 224, 230, 1)" />
                        </div>
                    </div>
                    <div id="voiceId"></div>
                    <!-- <button @click="changeUrl">切换视频</button>
                    <div style="width:100%;height:480;position:absolute;bottom:0px;left:0px;">
                        <video id="playVideos" width="100%" height="240" muted autoplay loop>
                            <source :src="videoUrl" type="video/mp4">
                            您的浏览器不支持 HTML5 video 标签。
                        </video>
                    </div> -->
                </div>
            </div>
        </div>
        <div class="content-phone">
            <div style="display:flex;flex-direction:column;height:100%">
                <div @click="tryVoice" style="height:50px;line-height:50px;background:rgba(65, 224, 230, 1);color:#fff;text-align:center;">
                    <a-icon style="transform:rotate(100deg);font-size:20px;" type="phone" />
                    <span style="font-size:16px;margin-left:4px;">语音体验</span>
                </div>
                <div style="flex:1;padding:16px;overflow-y:auto;">
                    <div class="chat-content">
                        <div v-for="(item, index) in privateChatContent" :key="index" class="dialog-list">
                            <div v-if="item.role=='robot'" class="left" style="max-width:70%">
                                <div :class="{'bgleft':item.role=='robot'}">
                                    <img src="../../assets/img/chat-head.png" class="left" alt="">
                                    <div style="flex:1;background:#fff;padding:4px 8px;border-radius:4px" class="content-info left">
                                        <div style="font-size:14px">{{item.content}}</div>
                                    </div>
                                </div>
                            </div>
                            <div v-if="item.role=='user'" class="right" style="max-width:70%;cursor:pointer">
                                <div :class="{'bgright':item.role=='user'}">
                                    <div style="flex:1;background:rgba(65, 224, 230, 1);padding:4px 8px;border-radius:4px" class="content-info right">
                                        <div style="font-size:14px">{{item.content}}</div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div style="display:flex;width:100%;height:40px;padding:0 16px;margin-bottom:10px;position:relative">
                    <div v-if="isEnd" style="position:absolute;top:-30px;left:50%;font-size:16px;color:#000;margin-left:-40px">通话已结束</div>
                    <a-input  :disabled="isFinish" v-model="privateContent" style="flex:1;height:40px"/>
                    <a-button id="input-send" type="primary" style="width:66px;height:40px;margin-left:8px;background:rgba(65, 224, 230, 1)" @click="sendPrivate">
                        发送
                    </a-button>
                </div>
            </div>
        </div>
        <a-modal v-model="visible" :footer="null" :maskClosable="false">
            <div style="height:315px;width:100%;padding-top:22px;position:relative">
                <div style="padding:0 22px;">   
                    <div style="color:rgba(32, 32, 32, 1);font-size:17px;font-weight:bold;text-align:center">请输入您的手机号</div>
                    <div style="color:rgba(80, 80, 80, 1);font-size:14px;padding:18px 0">请输入您的手机号码，我们的机器人会及时给您回电</div>
                    <a-input v-model="userPhone" style="height:40px;border:1px solid rgba(65, 224, 230, 1);border-radius:3px;width:100%">
                        <a-icon slot="prefix" type="mobile" />
                    </a-input>
                    <div style="margin-top:16px;color:rgba(65, 224, 230, 1);font-size:12px;">* 温馨提示</div>
                    <div style="color:rgba(153, 153, 153, 1);font-size:12px;margin-top:4px;">您输入的手机号仅用于电话模拟，不用于其他任何地方，我们会保护您的隐私安全，请放心试用</div>
                </div>
                
                <div style="position:absolute;height:45px;line-height:45px;bottom:0px;left:0px;border-top:1px solid rgba(238, 238, 238, 1);width:100%;text-align:center">
                    <div @click="offVisible" style="width:50%;height:100%;float:left;display:inline-block;font-size:15px;color:rgba(56, 56, 56, 1);border-right:1px solid rgba(238, 238, 238, 1)">取消</div>
                    <div @click="playCall('phone')" style="width:50%;height:100%;float:left;display:inline-block;font-size:15px;color:rgba(65, 224, 230, 1)">提交</div>
                </div>
            </div>
        </a-modal>
    </div>
</template>

<script>
export default {
    name: 'Chat',
    props: {
        
    },
    data() {
        return {
            projectId: '',
            projectName: '',
            des: '',
            userPhone: '',
            roomId: '',
            countDown: 120,
            privateChatContent: [],
            isFinish: false,
            isEnd: false,
            ifCanOperate: false,
            countTimeTool: '',
            privateChatObj: {},
            privateContent: '',
            intentionList: [],
            currentWord: '',
            visible: false,
            projectUrl: '',
            ifCanUse: false,
            buttonHtml: '提交',
            phoneId: '',
            timer: null, //定时器名称
            ifRestart: false,
            countNumber: 0,
            videoUrl: 'https://www.runoob.com/try/demo_source/mov_bbb.mp4'
        };
    },
    methods: {
        changeUrl() {
            let audio = "<audio autoplay=\"autoplay\">" + "<source src='http://47.111.165.100:8005/tts?text=提前挂机哈哈哈哈哈哈哈哈哈哈哈&format=wav&speaker=840590587471069185&voice=Aixia&speechRate=0'" + "\" type=\"audio/mpeg\">" + "<embed height=\"0\" width=\"0\" src='http://47.111.165.100:8005/tts?text=提前挂机哈哈哈哈哈哈哈哈哈哈哈&format=wav&speaker=840590587471069185&voice=Aixia&speechRate=0'" + "\">" + "</audio>";
            let oBox=document.getElementById("voiceId");
            oBox.innerHTML = audio
            let vdo = document.getElementById("playVideos")
            vdo.src = 'https://www.runoob.com/try/demo_source/mov_bbb.ogg';
        },

        playCall(type) {
            this.axios.post('/api/public/project/phone', {
                phone: this.userPhone,
                projectId: this.projectId
            })
            .then(response=> {
                if(response.data.code == 0){
                    this.visible = false;
                    this.$message.success('已呼出');
                    if(type == 'pc'){
                        this.buttonHtml = '正在呼叫...'
                        this.isFinish = true
                        this.ifCanOperate = true
                        this.phoneId = response.data.data.id
                        this.ifCanUse = true
                        this.ifRestart = true
                        // clearInterval(this.countTimeTool)
                        this.timer = setInterval(
                            this.getChatContent, 1500
                        );
                        clearInterval(this.countTimeTool)
                        this.privateChatContent = []
                        this.currentWord = ''
                        this.intentionList = []
                    }
                }else{
                    this.$message.error(response.data.message);
                }
            })
            .catch(error=> {
                console.log(error)
            })
        },
        getChatContent() {
            this.axios(
                {
                    method:'get',
                    url:'/api/public/project/phoneChat/content', 
                    params: {
                        id: this.phoneId,
                    }
                }
            )
            .then(response=> {
                if(response.data.code == 0){
                    let res = response.data.data
                    if(res.callRecord.length!=0){
                        this.countNumber = 0
                        let currentLength = this.privateChatContent.length
                        let that = this
                        for(let i = 0; i < res.callRecord.length; i++){  
                            (function(i) {
                                setTimeout(function() {
                                    let obj = {}
                                    obj.role = res.callRecord[i]['role']=="USER"?'user':'robot'
                                    obj.content = res.callRecord[i]['word']
                                    that.privateChatContent.push(obj)
                                    that.privateChatObj[currentLength] = res.callRecord[i].log.intentionList
                                    if(res.callRecord[i]['role'] == 'USER'){
                                        that.currentWord = res.callRecord[i]['word']
                                        if(res.callRecord[i]['word']!=''){
                                            if(res.callRecord[i+1]){
                                                that.intentionList = res.callRecord[i+1]['log']['intentionList']
                                            }
                                        }
                                    }
                                    this.scrollTopCon()
                                }, (i + 1) * 1500);
                            })(i)      
                        }

                    }else{
                        this.countNumber ++
                        if(this.countNumber == 40){
                            clearInterval(this.timer)
                            this.timer = null;
                            this.buttonHtml = '通话已结束'
                        }
                    }
                    if(res['isFinish']){
                        clearInterval(this.timer)
                        this.timer = null;
                        this.buttonHtml = '通话已结束'
                    }
                }else{
                    this.$message.error(response.data.message);
                }
            })
            .catch(error=> {
                console.log(error)
            })
        },
        restartCall() {
            this.ifRestart = false
            this.currentWord = ''
            this.intentionList = []
            this.ifCanOperate = false
            this.ifCanUse = false
            this.privateChatContent = []
            this.userPhone = ''
            this.buttonHtml = '提交'
            this.isFinish = false
            this.isEnd = false
            this.privateContent = ''
            this.privateChatObj = {}
            clearInterval(this.timer)
            this.countDown = 120
            this.getRoomId(this.projectId)
        },
        randomTime() {
            let max = 3000;
            let min = 1000;
            return Math.round(Math.random()*(max-min)+min)
        },
        getRoomId() {
            this.axios.post('/api/project/chat', {
                projectId: this.projectId,
                roomId: '',
                content: ''
            })
            .then(response=> {
                if(response.data.code == 0){
                    clearInterval(this.countTimeTool)
                    this.countDown = 120
                    this.roomId = response.data.data.roomId
                    let obj = {}
                    obj.role = 'robot'
                    obj.content = response.data.data.responseContent
                    this.privateChatContent.push(obj)
                    if(response.data.data.isFinish){
                        this.isFinish = true
                        this.isEnd = true
                    }else{
                        this.carryTimeOut()
                    }
                }else{
                    this.$message.error(response.data.message);
                }
            })
            .catch(error=> {
                console.log(error)
            })
        },
        carryTimeOut() {
            this.countTimeTool = setInterval(this.myInterval,2000)
        },
        myInterval(){
            this.countDown -- 
            if(this.countDown == 0){
                clearInterval(this.countTimeTool)
                this.sendNullContent()
            }
        },
        sendNullContent() {
            let currentLength = this.privateChatContent.length//15618900917
            this.axios.post('/api/project/chat', {
                projectId: this.projectId,
                roomId: this.roomId,
                content: ""
            })
            .then(response=> {
                if(response.data.code == 0){
                    clearInterval(this.countTimeTool)
                    this.countDown = 120
                    let newObj = {}
                    newObj.role = 'robot'
                    newObj.content = response.data.data.responseContent
                    this.privateChatContent.push(newObj)
                    this.scrollTopCon()
                    this.privateChatObj[currentLength] = response.data.data.log.intentionList
                    if(response.data.data.isFinish){
                        this.isFinish = true
                        this.isEnd = true
                    }else{
                        this.carryTimeOut()
                    }
                }else{
                    this.$message.error(response.data.message);
                }
            })
            .catch(error=> {
                console.log(error)
            })
        },
        scrollTopCon() {
            this.$nextTick(function() {
                let div = document.getElementById('chatDiv');
                div.scrollTop = div.scrollHeight;
            })
        },
        sendPrivate() {
            this.privateContent = (this.privateContent).replace(/\s/g,"");
            if(this.privateContent.length == 0){
                this.$message.error('请输入对话内容');
                this.privateContent = ''
            }else{
                let obj = {}
                obj.role = 'user'
                obj.content = this.privateContent
                let currentLength = this.privateChatContent.length
                this.privateChatContent.push(obj)
                this.scrollTopCon()
                this.currentWord = this.privateContent
                this.axios.post('/api/project/chat', {
                    projectId: this.projectId,
                    roomId: this.roomId,
                    content: this.privateContent
                })
                .then(response=> {
                    if(response.data.code == 0){
                        clearInterval(this.countTimeTool)
                        this.countDown = 120
                        let newObj = {}
                        newObj.role = 'robot'
                        newObj.content = response.data.data.responseContent
                        let randomTime = this.randomTime()
                        setTimeout(()=>{
                            this.privateChatContent.push(newObj)
                            this.scrollTopCon()
                            this.privateChatObj[currentLength] = response.data.data.log.intentionList
                            this.intentionList = response.data.data.log.intentionList
                            if(response.data.data.isFinish){
                                this.isFinish = true
                                this.isEnd = true
                            }else{
                                this.carryTimeOut()
                            }
                        },randomTime)
                    }else{
                        this.$message.error(response.data.message);
                    }
                })
                .catch(error=> {
                    console.log(error)
                })
                this.privateContent = ''
            }
        },
        resetPrivate() {
            this.isFinish = false
            this.isEnd = false
            this.privateContent = ''
            this.privateChatContent = []
            this.privateChatObj = {}
            this.currentWord = ''
            this.intentionList = []
            clearInterval(this.countTimeTool)
            this.countDown = 120
            this.getRoomId(this.projectId)
        },
        queryUserIntentionData(index,content) {
            this.intentionList = this.privateChatObj[index]
            this.currentWord = content
        },
        tryVoice() {
            this.visible = true;
        },
        offVisible(){
            this.visible = false;
        },
        queryBasicInfo() {
            let host = window.location.host
            this.axios(
                {
                method:'get',
                url:'/api/login/loginInfo', 
                params: {
                    hostName: host,
                }
            })
            .then(response=> {
                if(response.data.code == 0){
                    document.title = response.data.data.sysName;
                    const favicon = document.getElementById('dynamic-favicon');
                    favicon.href = response.data.data.titleLogo
                }else{
                    this.$message.error(response.data.message);
                }
            })
            .catch(error=> {
                console.log(error)
            })
        }
    },
    beforeDestroy(){
        clearInterval(this.timer);
        this.timer = null;
    },
    mounted: function () {
        this.projectId = this.$route.query.projectId
        this.projectName = this.$route.query.projectName.split("@@")[0]
        this.projectUrl = this.$route.query.projectName.split("@@")[1]
        this.des = this.$route.query.des
        this.getRoomId()
        this.queryBasicInfo()
    }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="less">
    .chat{
        height: 100%;
        #projectName:hover{
            text-decoration:none !important;
        }
        .content-phone{
            display: none;
        }
        .content-pc{
            height: 100%;
            display: flex;
            flex-direction: column;
        }
        .left{
            float: left;
        }
        .right{
            float: right;
        }
        .head{
            height: 85px;
            background: rgba(9, 18, 43, 1);
            .nav-list{
                padding-right: 92px;
            }
            .nav-list a{
                color: #fff;
                font-size: 14px;
                line-height: 85px;
                margin: 0 20px;
            }
            .nav-list a:hover{
                color: rgba(24, 144, 255, 1);
            }
        }
        .content{
            flex: 1;
            background: rgba(240, 242, 243, 1);
            padding: 24px;
            display: flex;
            .content-left{
                width: 360px;
                display: flex;
                flex-direction: column;
                .item-top{
                    flex: 1;
                    background: #fff;
                    padding: 16px 24px;
                    box-sizing: border-box;
                }
                .item-bottom{
                    height: 354px;
                    background: #fff;
                    margin-top:16px;
                    padding: 16px 24px;
                    box-sizing: border-box;
                }
            }
            .content-middle{
                flex: 1;
                margin: 0 16px;
                height: 100%;
                background: rgba(255, 255, 255, 0.45);
                padding: 16px 0 0 0;
                box-sizing: border-box;
                display: flex;
                flex-direction: column;
            }
            .content-right{
                width: 360px;
                height: 100%;
                background: #fff;
                padding: 16px 24px;
                box-sizing: border-box;
                position: relative;
            }
        }
        .ant-btn{
            color: #fff !important;
        }
        .resetText{
            color:rgb(65, 224, 230) !important;
            padding: 0px !important;
        }
    }
    @media only screen and (max-width: 770px) {
        .chat{
            display: block;
            justify-content: initial;//使子项目水平居中
            align-items: initial;//使子项目垂直居中
            height: 100%;;
            .content-pc{
                display:none;
            }
            .content-phone{
                display: block;
                height: 100%;
                background: rgba(246, 247, 248, 1);
                .chat-content{
                    img{
                        width: 24px;
                    }
                }
                .dialog-list{
                    width: 100%;
                    float: left;
                    margin-bottom: 16px;
                    .bgleft{
                        padding: 8px 0;
                        border-radius: 8px;
                        height: 100%;
                        float: left;
                        padding-right: 10px;
                        width: 100%;
                        display: flex;
                    }
                    .bgright{
                        padding: 8px 0;
                        border-radius: 8px;
                        color: #fff;
                        height: 100%;
                        float: right;
                        padding-left: 10px;
                        display: flex;
                    }
                    img{
                        width: 32px;
                        height: 32px;
                        border-radius: 16px;
                        margin-right: 10px;
                        margin-left: 10px;
                    }
                    font-size: 12px;
                }
            }
        }
    }
</style>
